import { mapState, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import Constants from '@/utils/Constants'
import Jsonb from '@/utils/Jsonb'

export default {
  name: 'Item',
  components: {
    FileSelectorButton
  },
  props: {
    index: Number
  },
  data () {
    return {
      inited: false,

      // input
      input: {
        name: null,
        linkCategory: '',
        dataSourceType: '',
        parameters: null,
        pdfFile: null
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      values: state => state.serviceFunctionDetail.values,

      // form
      serviceUuid: state => state.serviceFunctionDetail.serviceId,

      // リンク集カテゴリ
      linkCategoryList: state => state.serviceLinkCategory.values,
    }),

    title () {
      return 'リンク ' + (this.index + 1)
    },

    // list
    sourceTypeList () {
      return Constants.Service.LinkSourceType
    },

    // input
    inpRecommededLinkUrls: {
      get () {
        return this.values.inpRecommededLinkUrls
      },
      set (value) {
        this.setInputValue({
          key: 'inpRecommededLinkUrls',
          value: value
        })
      }
    },

    linkCategories() {
      return this.linkCategoryList
    }

    // // validate
    // formIsValid () {
      
    // },
  },
  watch: {
    'input.dataSourceType': function (to) {
      if (this.inited) {
        this.$set(this.input, 'parameters', null)
        this.$set(this.input, 'pdfFile', null)
      }
    },
    'input.linkCategory': {
      handler(to) {
        this.$emit('input', to)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setInputValue: 'serviceFunctionDetail/setInputValue',
    }),

    init () {
      if (this.inpRecommededLinkUrls[this.index].name)
        this.input.name = this.inpRecommededLinkUrls[this.index].name
      if (this.inpRecommededLinkUrls[this.index].category)
        this.input.linkCategory = this.linkCategoryList.some(
          item =>
            item.linkCategoryUuid ===
            this.inpRecommededLinkUrls[this.index].category.uuid
        )
          ? this.inpRecommededLinkUrls[this.index].category.uuid
          : "";
      if (this.inpRecommededLinkUrls[this.index].dataSourceType !== '')
        this.input.dataSourceType = this.inpRecommededLinkUrls[this.index].dataSourceType
      if (this.inpRecommededLinkUrls[this.index].parameters)
        this.input.parameters = this.inpRecommededLinkUrls[this.index].parameters
      if (this.inpRecommededLinkUrls[this.index].pdfFile)
        this.input.pdfFile = this.inpRecommededLinkUrls[this.index].pdfFile

      this.$nextTick(() => this.inited = true)
    },

    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let name = props.name.split(this.index).join('')
      if (name !== 'pdfFile') return
      console.log('changeFileFromSelector', props)
      this.$set(this.input, name, Jsonb.formatFile(props.data))
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let name = props.name.split(this.index).join('')
      if (name !== 'pdfFile') return
      console.log('deleteFileFromSelector', props)
      this.$set(this.input, name, null)
    },
  }
}